export default __webpack_public_path__ + "static/media/curriculumSection2pattern.a253cd30.svg";